import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { connect } from 'react-redux';
import { getIsGenericTwoFactorErrorAlertVisible } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const GenericTwoFactorErrorAlert = ({
  isGenericTwoFactorErrorAlertVisible
}) => {
  if (!isGenericTwoFactorErrorAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: I18n.text('login.twoFactor.errors.generic.title'),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "login.twoFactor.errors.generic.body"
    })
  });
};
const mapStateToProps = state => ({
  isGenericTwoFactorErrorAlertVisible: getIsGenericTwoFactorErrorAlertVisible(state)
});
export default connect(mapStateToProps)(GenericTwoFactorErrorAlert);